export function initializeNavigation(): void {
  document.addEventListener("DOMContentLoaded", function () {
    const menuToggle = document.querySelectorAll(".menu-toggle");

    menuToggle.forEach((toggle) => {
      // Initialize aria-expanded if not present
      if (!toggle.hasAttribute("aria-expanded")) {
        toggle.setAttribute("aria-expanded", "false");
      }

      // Toggle on click
      toggle.addEventListener("click", function () {
        const isExpanded = this.getAttribute("aria-expanded") === "true";
        this.setAttribute("aria-expanded", isExpanded ? "false" : "true");

        toggle.querySelectorAll(".submenu-item").forEach((submenu) => {
          submenu.setAttribute("aria-expanded", "false");
        });
      });

      // Close on Escape key
      document.addEventListener("keydown", function (event: KeyboardEvent) {
        if (event.key === "Escape") {
          toggle.setAttribute("aria-expanded", "false");

          toggle.querySelectorAll(".submenu-item").forEach((submenu) => {
            submenu.setAttribute("aria-expanded", "false");
          });
        }
      });
    });

    const submenus = document.querySelectorAll<HTMLElement>(
      "nav.mobile .top-level-menu .submenu-item"
    );

    submenus.forEach((submenu) => {
      // Initialize aria-expanded if not present
      if (!submenu.hasAttribute("aria-expanded")) {
        submenu.setAttribute("aria-expanded", "false");
      }

      // Toggle on click
      submenu.addEventListener("click", function () {
        const isExpanded = this.getAttribute("aria-expanded") === "true";
        this.setAttribute("aria-expanded", isExpanded ? "false" : "true");
      });
    });
  });
}
